import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import { RecoilRoot } from "recoil";
import { AppRouter } from "./routes/AppRouter";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import StylesGlobal from "./layout/StylesGlobal";
import GlobalShowSnackbar from "./shared/components/alerts/GlobalShowSnackbar";
import authGuestAction from "./Patient/actions/authGuestAction";
import VerifyPatientRegister from "./shared/components/patient/VerifyPatientRegister";
import ModalEditFilters from "./SearchHours/components/modalEditFilters/ModalEditFilters";
import ModalShowPhoto from "./Professional/ModalShowPhoto";
import Preloader from "./shared/components/loadings/Preloader";
import ReagendarHora from "./ResultSearch/components/ReagendarHora";
import AgendarHoraEsp from "./ResultSearch/components/AgendarHoraEsp";
import queryString from "query-string";
import MedicoAgendaDirecta from "./ResultSearch/components/MedicoAgendaDirecta";
import TotemAgenda from "./ResultSearch/components/TotemAgenda";
import AgendarHoraExterno from "./ResultSearch/components/AgendarHoraExterno";
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import ModalEditFiltersProc from "./SearchHours/components/modalEditFilters/ModalEditFiltersProc";
import ModalEditFiltersImg from "./SearchHours/components/modalEditFilters/ModalEditFilterImg";
import ModalFamilyGroup from "./FamilyGroup/components/ModalFamilyGroup";
import { ModalConfirmFamilyGroup } from "./FamilyGroup/components/ModalConfirmFamilyGroup";
import ConfiguracionService from "./services/config/configuracion";
import { initConfig } from "./config/appConfig";
import PreloaderCustom from "./shared/components/loadings/PreloaderCustom";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
};

function App() {
  const query = queryString.parse(window.location.search);

  const initReactGA = () => {
    ReactGA.initialize(process.env.REACT_APP_ANALYTICS_4);
    //ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  };

  const initReactGTM = () => {
    TagManager.initialize(tagManagerArgs);
  };

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const response = await ConfiguracionService.getParametrosIniciales();
        initConfig(response);
      } catch (e) {
        console.error("Error cargando config inicial", e);
        // decidir si igual dejar pasar o mostrar error
      } finally {
        setIsReady(true);
      }
    };
    init();
  }, []);

  useEffect(() => {
    authGuestAction();
    initReactGA();
    initReactGTM();
  }, []);

  if (!isReady) return <PreloaderCustom />;

  return (
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StylesGlobal theme={theme} />
        {query && query.ra_id !== undefined && query.ra_id !== "" && (
          <ReagendarHora />
        )}
        {query && query.qrp !== undefined && query.qrp !== "" && (
          <MedicoAgendaDirecta />
        )}
        {query && query.totem !== undefined && query.totem !== "" && (
          <TotemAgenda />
        )}
        {query && query.ext !== undefined && query.ext !== "" && (
          <AgendarHoraExterno />
        )}
        {query && query.qec !== undefined && query.qec !== "" && (
          <AgendarHoraEsp />
        )}

        <VerifyPatientRegister />
        <GlobalShowSnackbar />

        <ModalEditFilters />
        <ModalEditFiltersImg />
        <ModalEditFiltersProc />
        <ModalShowPhoto />
        <ModalFamilyGroup />
        <ModalConfirmFamilyGroup />
        <Suspense fallback={null}>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </Suspense>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default App;
